import * as React from 'react';
import { FlexRow, Icon, IconSize, IconType } from 'ui-toolkit';

interface IUpdateMessage {
  fetchedSuccess: boolean;
  messageText?: string;
}

const UpdateMessage: React.FunctionComponent<IUpdateMessage> = (props) => {
  return (
    <>
      {props.fetchedSuccess ? (
        <FlexRow>
          <Icon type={IconType.Check} size={IconSize.Small} />
          <span>{props.messageText ? props.messageText : 'Updated!'}</span>
        </FlexRow>
      ) : null}
    </>
  );
};

export default UpdateMessage;
